import { SELECT_DEALER } from 'constants/ActionTypes';
import { SORT } from 'constants/FilterConstants';
import { SELF_SERVICE_TOP_CONTRIBUTORS_DEFAULT_SORT } from 'constants/StatisticsConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import * as types from 'modules/statistics/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const emptyState = {
  [SORT]: SELF_SERVICE_TOP_CONTRIBUTORS_DEFAULT_SORT,
};

/** @type {FilterAdapter<TopContributorsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_SELF_SERVICE_TOP_CONTRIBUTORS_FILTER]: filterAdapter.setFilter,
  [SELECT_DEALER]: filterAdapter.resetFilters,
  [SELECT_GROUP]: filterAdapter.resetFilters,
});
